import React from 'react';

export default function Spinner({ className = '' }) {
  return (
    <div className={`eg-spinner-wrap ${className}`}>
      <div className="eg-spinner" />
    </div>
  );
}

export function PageLoader() {
  return (
    <div className="container-fluid section-my">
      <Spinner />
    </div>
  );
}
